export class PanelSettingEntity {
  id?: number
  showCompletedOrderDurationInSecond?: number
  showCanceledOrderDurationInSecond?: number
  minimumPrizeCountForSpin?: number
  userPrizeExpirationTimeInDays?: number
  showOutOfStockItem?: boolean
  userSpinWheelExpirationTimeInHours?: number
  defaultBranchDistanceCapInKm?: number | null

  useCentralizedAutoDispatchFlow?: boolean
}
